import React from 'react'
import {Switch, Route, Redirect, HashRouter, BrowserRouter} from 'react-router-dom'
import './App.css'
import Home from './view/home'
import Token from './view/token'
import Empty from './view/empty'
import Login from "./view/login";
import Agreement from "./view/agreement";
import Policy from "./view/policy";
import RequireAuth from './components/auth'

class App extends React.Component {

    render() {
        return (
            <Switch>
                <Route path="/home" component={Home}/>
                <Route path="/login" exact component={Login}/>
                <Route path="/argreement" exact component={Agreement}/>
                <Route path="/policy" exact component={Policy}/>
                <Route path="/*" exact component={Empty}/>
            </Switch>
        )
    }
}

export default App